import { Api } from '../base/Api';
import { Injectable } from '@angular/core';
import { Product } from 'src/app/models/Product';
@Injectable({
    providedIn: 'root'
})
export class ProductApi extends Api<Product> {
}
